// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--2X1Uv";
export var ul = "Footer-module--ul--nPtBX";
export var link = "Footer-module--link--LZRFQ";
export var copyright_text = "Footer-module--copyright_text--l-jpP";